import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/index.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/')({
  component: Content,
});
